import React, { useState, useEffect, useRef, Fragment } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from "../../layouts/dropdown/Dropdown";
import { requestApi } from "../../../request-api";
import { toast } from "react-toastify";
import { API_URL } from "../../../config";
import VectorIcon from "../../../assets/image/Vector.svg";
import Closed from "../../../assets/image/Closed.svg";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import jsPDF from "jspdf";
import "jspdf-autotable";
import exportIcon from "../../../assets/image/document-download.png";
import { isLocalDateInRange } from "../../../helpers/complianceDashboard";

function ApproversReports() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [reports, setReports] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companySearchName, setCompanySearchName] = useState("");

  const [actSearchName, setActSearchName] = useState("");
  const [selectedAct, setSelectedAct] = useState([]);
  const dateDropdownRef = useRef(null);

  const [selectedLocation, setSelectedLocation] = useState("");
  const [locationSearchName, setLocationSearchName] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);

  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [activeFilter, setActiveFilter] = useState("This Month");
  const [filterDateWise, setFilterDateWise] = useState({
    startDate: defaultStart,
    endDate: defaultEnd,
  });

  const [filteredReport, setFilteredReport] = useState([]);

  const [compliance, setCompliance] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    accepted: "",
    comment: "",
  });

  const [selectedStatus, setSelectedStatus] = useState("Status");

  const [loading, setLoading] = useState(false);
  const [format, setFormat] = useState("pdf");
  const [period, setPeriod] = useState("Monthly");
  const [showDropdown1, setShowDropdown1] = useState(false);
  const dropdownRef1 = useRef(null);

  const formats = [
    { label: "Pdf", icon: "bi-file-earmark-pdf", value: "pdf" },
    { label: "Excel", icon: "bi-file-earmark-excel", value: "excel" },
  ];
  const periods = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredReport.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredReport.length / itemsPerPage);
  const visiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    let filtered = [...reports];

    // Apply date filter
    if (filterDateWise.startDate && filterDateWise.endDate) {
      filtered = filtered.filter((item) =>
        isLocalDateInRange(item.due_date, filterDateWise.startDate, filterDateWise.endDate)
      );
    }

    if (selectedCompany.length > 0) {
      filtered = filtered.filter((item) =>
        selectedCompany.includes(item.company_name)
      );
    }

    if (selectedLocation.length > 0) {
      filtered = filtered.filter((item) =>
        selectedLocation.includes(item.location)
      );
    }

    if (selectedAct.length > 0) {
      filtered = filtered.filter((item) =>
        selectedAct.includes(item.legislation_name)
      );
    }
    if (selectedSubBranches.length > 0) {
      filtered = filtered.filter((item) =>
        selectedSubBranches.includes(item.sub_branch)
      );
    }

    if (selectedStatus === "open") {
      filtered = filtered.filter((item) => item.open_close == 0);
    } else if (selectedStatus === "closed") {
      filtered = filtered.filter((item) => item.open_close == 1);
    }

    setFilteredReport(filtered);
    setCurrentPage(1);
  }, [
    reports,
    filterDateWise,
    selectedCompany,
    selectedLocation,
    selectedAct,
    selectedSubBranches,
    selectedStatus,
  ]);

  useEffect(() => {
    console.log("selectedStatus", selectedStatus);
  }, [selectedStatus]);

  const toggleCompanySelection = (item) => {
    setSelectedCompany((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleActSelection = (item) => {
    setSelectedAct((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleLocationSelection = (item) => {
    setSelectedLocation((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  async function fetchReports() {
    setLoading(true);

    try {
      const { data } = await requestApi("/approver/fetch/by-approver", {
        method: "get",
      });

      setReports(data);

      const _companies = [...new Set(data.map((item) => item.company_name))];
      const _locations = [...new Set(data.map((item) => item.location))];
      const _subBranches = [...new Set(data.map((item) => item.sub_branch))];

      setLocations(_locations);
      setCompanies(_companies);
      setAvailableSubBranches(_subBranches);
    } catch (err) {
      toast.error(err?.data, "Failed to load report data!");
    } finally {
      setLoading(false);
    }
  }

  const handleQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "This Month":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setActiveFilter("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setFilterDateWise({ startDate: start, endDate: end });
    setActiveFilter(type);

    applyDateFilter({ startDate: start, endDate: end });
  };

  const applyDateFilter = (dates = filterDateWise) => {
    const dateFiltered = reports.filter((item) =>
      isLocalDateInRange(item.due_date, dates.startDate, dates.endDate)
    );

    const finalFiltered =
      selectedCompany.length > 0
        ? dateFiltered.filter((item) =>
          selectedCompany.includes(item.company_name)
        )
        : dateFiltered;

    setIsOpen(!isOpen);
    setFilteredReport(finalFiltered);
  };

  async function getCopmlianceById(id) {
    setLoading(true);

    try {
      const { data } = await requestApi(`/report/fetch/by-auditor/${id}`, {
        method: "get",
      });

      if (data) {
        setCompliance(data);
        setShowModal(true);
      } else {
        toast.error("No data found.");
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  async function handleUpdateModal(e, id) {
    e.preventDefault();

    if (!id) {
      toast.info("Compliance ID is missing. Please try again.");
      return;
    }

    if (!formData.accepted || !formData.comment) {
      toast.info(
        "Please add a comment and verify the checkbox before submitting."
      );
      return;
    }

    setLoading(true);

    try {
      const { statusCode } = await requestApi(`/report/verify-status/${id}`, {
        method: "put",
        body: JSON.stringify({
          open_closed: formData.accepted,
          comment_of_approver: formData.comment,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (statusCode === 200) {
        toast.success("Comment updated successfully!");

        setFormData({
          accepted: "",
          comment: "",
        });
        fetchReports();
        setShowModal(false);
      }
    } catch (err) {
      toast.error("Failed to update comment.");
    } finally {
      setLoading(false);
    }
  }

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const exportReport = (data, format, startDate, endDate) => {
    let exportData = [...data];
    
    if (startDate && endDate) {
      exportData = exportData.filter((item) =>
        isLocalDateInRange(item.due_date, startDate, endDate)
      );
    }

    if (selectedSubBranches.length > 0) {
      exportData = exportData.filter((item) =>
        selectedSubBranches.includes(item.sub_branch)
      );
    }

    if (
      !Array.isArray(exportData) ||
      exportData.length === 0 ||
      !exportData[0]
    ) {
      toast.error("No data found for the selected period.");
      return;
    }

    const headers = {
      sr_no: "ID",
      company_name: "Entity",
      branch_id: "Branch ID",
      legislation_name: "Legislation",
      desc: "Compliance Description",
      audited_date: "Audited Date",
      due_date: "Due Date",
      score: "Score",
      assigned_auditor: "Auditor",
      period: "Date of Compliance",
      assigned_compliance_officer: "Compliance Officer",
      curr: "Status",
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      return date.toLocaleDateString("en-GB"); // dd-mm-yyyy
    };

    const mapFormattedData = exportData.map((item, index) => {
      const mapped = {};

      for (const key in headers) {
        let val = "";

        // Serial number
        if (key === "sr_no") {
          val = index + 1;
        }
        // Score calculation
        else if (key === "score") {
          switch (item.curr) {
            case "Complied":
              val = "1";
              break;
            case "Partial Complied":
              val = "0.5";
              break;
            case "Not Complied":
            case "Not Applicable":
              val = "0";
              break;
            default:
              val = "-";
          }
        }
        // Date formatting
        else if (
          key.includes("date") ||
          key === "audited_date" ||
          key === "due_date" ||
          key === "period"
        ) {
          val = formatDate(item[key]);
        }
        // Normal fields
        else {
          val = item[key] ?? "";
        }

        mapped[headers[key]] = val;
      }

      return mapped;
    });

    if (format === "excel") {
      const displayHeaders = Object.values(headers);

      const uniqueCompanies = [
        ...new Set(
          exportData
            .map((item) => item.company_name || item.companyName || item.company)
            .filter(Boolean)
        ),
      ];
      let companyVal = "";
      if (uniqueCompanies.length > 0) {
        companyVal = uniqueCompanies.join(", ");
      } else if (
        typeof selectedCompany !== "undefined" &&
        selectedCompany &&
        (Array.isArray(selectedCompany) ? selectedCompany.length > 0 : Boolean(selectedCompany))
      ) {
        companyVal = Array.isArray(selectedCompany)
          ? selectedCompany.join(", ")
          : selectedCompany;
      } else {
        companyVal = "All Companies";
      }

      let locationVal = "All Locations";
      if (
        typeof selectedLocation !== "undefined" &&
        selectedLocation &&
        (Array.isArray(selectedLocation) ? selectedLocation.length > 0 : Boolean(selectedLocation))
      ) {
        locationVal = Array.isArray(selectedLocation)
          ? selectedLocation.join(", ")
          : selectedLocation;
      }

      let dateRangeVal = "All Dates";
      if (
        typeof filterDateWise !== "undefined" &&
        filterDateWise &&
        filterDateWise.startDate &&
        filterDateWise.endDate
      ) {
        dateRangeVal = `${filterDateWise.startDate} to ${filterDateWise.endDate}`;
      } else if (typeof period !== "undefined" && period) {
        dateRangeVal = period;
      }

      const getColumnLetter = (colIndex) => {
        let temp,
          letter = "";
        while (colIndex > 0) {
          temp = (colIndex - 1) % 26;
          letter = String.fromCharCode(65 + temp) + letter;
          colIndex = (colIndex - temp - 1) / 26;
        }
        return letter;
      };

      const totalCols = displayHeaders.length;
      const lastColLetter = getColumnLetter(totalCols);
      const totalRows = 4 + mapFormattedData.length;

      const worksheet = XLSX.utils.json_to_sheet(mapFormattedData, {
        origin: "A4",
      });

      const colWidths = displayHeaders.map((header) => ({
        wch: Math.max(header.length + 5, 18),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      XlsxPopulate.fromDataAsync(wbout)
        .then((wb) => {
          const sheet = wb.sheet(0);

          // 1. Row 1: Company Name in left corner
          const companyRange = sheet.range(`A1:${lastColLetter}1`);
          companyRange.merged(true);
          sheet.cell("A1").value(`Company Name: ${companyVal}`);
          companyRange.style({
            bold: true,
            fontSize: 12,
            horizontalAlignment: "left",
            verticalAlignment: "center",
          });

          // 2. Row 2: Location below Company Name
          const locationRange = sheet.range(`A2:${lastColLetter}2`);
          locationRange.merged(true);
          sheet.cell("A2").value(`Location: ${locationVal}`);
          locationRange.style({
            bold: true,
            fontSize: 11,
            horizontalAlignment: "left",
            verticalAlignment: "center",
          });

          // 3. Row 3: Period below Location
          const dateRange = sheet.range(`A3:${lastColLetter}3`);
          dateRange.merged(true);
          sheet.cell("A3").value(`Period: ${dateRangeVal}`);
          dateRange.style({
            bold: true,
            fontSize: 11,
            horizontalAlignment: "left",
            verticalAlignment: "center",
          });

          // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
          sheet.range(`A4:${lastColLetter}4`).style({
            bold: true,
            fontSize: 12,
            wrapText: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
            fill: "D9E1F2",
            border: true,
          });

          // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
          if (totalRows >= 5) {
            sheet.range(`A5:${lastColLetter}${totalRows}`).style({
              wrapText: true,
              fontSize: 10,
              verticalAlignment: "center",
              border: true,
            });
          }

          return wb.outputAsync();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = `ReportsApprover_Report_${period}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
          toast.success("Excel file exported successfully!");
        })
        .catch((error) => {
          console.error("Excel export error:", error);
          toast.error("Failed to export Excel file. Please try again.");
        });
    } else if (format === "pdf") {
      const newWindow = window.open();
      if (!newWindow) {
        toast.error("Please allow pop-ups to export PDF.");
        return;
      }

      const tableHeaders = Object.values(headers);
      const tableRows = mapFormattedData.map(
        (item) =>
          `<tr>${tableHeaders
            .map((h) => `<td>${item[h] ?? ""}</td>`)
            .join("")}</tr>`
      );

      const htmlContent = `
      <html>
        <head>
          <title>Reports Approver Report</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              table-layout: fixed;
              word-wrap: break-word;
            }
            th, td {
              border: 1px solid #000;
              padding: 4px;
              text-align: left;
            }
            th {
              background-color: #f0f0f0;
            }
            @media print {
              body {
                zoom: 50%;
              }
            }
          </style>
        </head>
        <body>
          <h2>Reports Approver Report - ${period}</h2>
          <table>
            <thead>
              <tr>${tableHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
            </thead>
            <tbody>${tableRows.join("")}</tbody>
          </table>
        </body>
      </html>
    `;
      newWindow.document.write(htmlContent);
      newWindow.document.close();
      newWindow.print();
      toast.success("PDF opened for printing!");
    }
  };

  const toggleDropdown1 = () => {
    setShowDropdown1((prev) => !prev);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className=" ">
        <div className="d-flex ">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {" "}
          </div>
        </div>
      </div>
      <div className="mt-2">
        <div className="d-flex " style={{ gap: "15rem" }}>
          <div className="d-flex gap-4">
            <div className="dropdown">
              <button
                className="btn d-flex align-items-center gap-2 "
                type="button"
                data-bs-toggle="dropdown"
                style={{
                  border: "1px solid #E4E4E7",
                  backgroundColor: "#FFFFFF",
                  color: "#1F1F23",
                  borderRadius: "5px",
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: "500",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                }}
              >
                Select Company Name
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="black"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                  />
                </svg>
              </button>
              <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                <div className="border p-2 rounded mb-2">
                  <div>
                    {selectedCompany.length > 0
                      ? selectedCompany.map((item, index) => (
                        <span
                          key={index}
                          className="bg-dark text-white px-1 rounded me-1"
                        >
                          {item}
                        </span>
                      ))
                      : "Select Name"}
                  </div>
                </div>
                <li className="">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={companySearchName}
                    onChange={(e) => setCompanySearchName(e.target.value)}
                  />
                </li>
                <div className="mt-2 w-full">
                  {companies
                    ?.filter((c) =>
                      c.toLowerCase().includes(companySearchName.toLowerCase())
                    )
                    ?.map((company) => (
                      <li
                        className="form-check d-flex justify-content-between align-items-center py-1 gap-2 border-bottom"
                        key={company}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedCompany.includes(company)}
                          onChange={() => toggleCompanySelection(company)}
                        />
                        <label className="form-check-label flex-grow-1 fs-12">
                          {company}
                        </label>
                      </li>
                    ))}
                </div>
              </ul>
            </div>
            <Dropdown
              label="Sub Branch"
              options={availableSubBranches}
              selectedItems={selectedSubBranches}
              setSelectedItems={setSelectedSubBranches}
            />

            <div className="">
              <div className="dropdown">
                <button
                  className="btn d-flex align-items-center gap-2"
                  type="button"
                  data-bs-toggle="dropdown"
                  style={{
                    border: "1px solid #E4E4E7",
                    backgroundColor: "#FFFFFF",
                    color: "#1F1F23",
                    borderRadius: "5px",
                    padding: "6px 14px",
                    fontSize: "14px",
                    fontWeight: "500",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  }}
                >
                  <span className="text-dark fs-12">Act</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="black"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                    />
                  </svg>
                </button>
                <div
                  className="dropdown-menu p-2 shadow "
                  style={{ width: "350px" }}
                >
                  <input
                    type="text"
                    className="form-control mb-2 fs-12"
                    placeholder="Search"
                    value={actSearchName}
                    onChange={(e) => setActSearchName(e.target.value)}
                  />
                  <div
                    style={{
                      // maxWidth: "350px",
                      // overflowX: "auto",
                      maxHeight: "200px",
                      overflowY: "auto",
                      scrollbarHeight: "5px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <div className="list-group border-0">
                      {[
                        ...new Set(
                          reports.map((item) => item.legislation_name)
                        ),
                      ]
                        .filter((name) =>
                          name
                            .toLowerCase()
                            .includes(actSearchName.toLowerCase())
                        )
                        .map((name, index) => (
                          <Fragment key={index}>
                            <label
                              className="list-group-item text-muted border-bottom border-0 d-flex align-items-center"
                              style={{
                                fontSize: "12px",
                                minWidth: "600px",
                              }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input me-2 fs-12"
                                checked={selectedAct.includes(name)}
                                onChange={() => toggleActSelection(name)}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  flexShrink: 0,
                                  cursor: "pointer",
                                }}
                              />
                              {name}
                            </label>
                          </Fragment>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <button
                className="btn d-flex align-items-center gap-2"
                type="button"
                data-bs-toggle="dropdown"
                style={{
                  border: "1px solid #E4E4E7",
                  backgroundColor: "#FFFFFF",
                  color: "#1F1F23",
                  borderRadius: "5px",
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: "500",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                }}
              >
                Select Location
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="black"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                  />
                </svg>
              </button>
              <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                <div className="border p-2 rounded mb-2">
                  <div>
                    {selectedLocation.length > 0
                      ? selectedLocation.map((item, index) => (
                        <span
                          key={index}
                          className="bg-dark text-white px-1 rounded me-1 fs-12"
                        >
                          {item}
                        </span>
                      ))
                      : "Select Name"}
                  </div>
                </div>
                <li className="">
                  <input
                    type="text"
                    className="form-control fs-12"
                    placeholder="Search"
                    value={locationSearchName}
                    onChange={(e) => setLocationSearchName(e.target.value)}
                  />
                </li>
                <div className="mt-2 w-full" style={{
                  // maxWidth: "350px",
                  // overflowX: "auto",
                  maxHeight: "200px",
                  overflowY: "auto",
                  scrollbarHeight: "5px",
                  scrollbarWidth: "thin",
                }}>
                  {locations
                    ?.filter((c) =>
                      c
                        ?.toLowerCase()
                        ?.includes(locationSearchName.toLowerCase())
                    )
                    ?.map((location) => (
                      <li
                        className="form-check d-flex justify-content-between  gap-2 align-items-center py-1 border-bottom"
                        key={location}
                      >
                        <input
                          className="form-check-input fs-12"
                          type="checkbox"
                          checked={selectedLocation.includes(location)}
                          onChange={() => toggleLocationSelection(location)}
                        />
                        <label className="form-check-label flex-grow-1 fs-12 ">
                          {location}
                        </label>
                      </li>
                    ))}
                </div>
              </ul>
            </div>
            <div className="position-relative d-inline-block" ref={dateDropdownRef}>
              <button
                className="btn bg-white border border-secondary-subtle d-flex align-items-center gap-2 w-20 py-1.5"
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                  alt="Calendar Icon"
                  width="16"
                  height="16"
                />
                <span className="fs-12">
                  {filterDateWise.startDate && filterDateWise.endDate
                    ? `${filterDateWise.startDate.toLocaleDateString("en-GB")} - ${filterDateWise.endDate.toLocaleDateString("en-GB")}`
                    : "Select Date"}
                </span>
              </button>
              {isOpen && (
                <div
                  className="position-absolute mt-2 bg-white border shadow p-3"
                  style={{
                    zIndex: 1000,
                    width: "718px",
                    maxWidth: "95vw",
                    right: 0,
                    overflow: "hidden",
                  }}

                >
                  <div className="row">
                    <div className="col-md-3">
                      <ul className="list-group fs-12">
                        {[
                          "This Month",
                          "Today",
                          "Yesterday",
                          "Last 7 days",
                          "Last 30 days",
                          "Manual",
                        ].map((label) => (
                          <li
                            key={label}
                            className={`list-group-item fs-12 ${activeFilter === label ? "bg-light rounded" : ""
                              }`}
                            style={{ border: "none", cursor: "pointer" }}
                            onClick={() => handleQuickFilter(label)}
                          >
                            {label}
                          </li>
                        ))}
                      </ul>
                    </div>
                    {activeFilter === "Manual" && (
                      <div className="col-md-9 border-start">
                        <div className="row">
                          <div className="col-md-6">
                            <DatePicker
                              selected={filterDateWise.startDate}
                              onChange={(date) =>
                                setFilterDateWise((prev) => ({
                                  ...prev,
                                  startDate: date,
                                }))
                              }
                              inline
                            />
                          </div>
                          <div className="col-md-6">
                            <DatePicker
                              selected={filterDateWise.endDate}
                              onChange={(date) =>
                                setFilterDateWise((prev) => ({
                                  ...prev,
                                  endDate: date,
                                }))
                              }
                              inline
                            />
                          </div>
                        </div>
                        <div className="mt-3 d-flex justify-content-between align-items-center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: "#343a40",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                              }}
                            >
                              {filterDateWise.startDate?.toLocaleDateString(
                                "en-GB"
                              )}
                            </span>

                            <span style={{ fontSize: "16px", color: "#000" }}>
                              →
                            </span>

                            <span
                              style={{
                                backgroundColor: "#343a40",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                              }}
                            >
                              {filterDateWise.endDate?.toLocaleDateString(
                                "en-GB"
                              )}
                            </span>
                          </div>
                          <button
                            className="btn btn-dark fs-12"
                            onClick={() => applyDateFilter()}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="dropdown">
              <button
                className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh"
                data-bs-toggle="dropdown"
              >
                <span className="text-dark fs-12">
                  {selectedStatus.charAt(0).toUpperCase() +
                    selectedStatus.slice(1) || "Select Status"}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="black"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                  />
                </svg>
              </button>

              <div
                className="dropdown-menu p-2 shadow"
                style={{ width: "200px" }}
              >
                <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                  <div className="list-group border-0 ">
                    {["open", "closed"].map((status, index) => (
                      <button
                        key={index}
                        className="list-group-item text-muted border-bottom border-0 d-flex align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedStatus(status)}
                      >
                        {status.charAt(0).toUpperCase() + status.slice(1)}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

              <div className="d-flex justify-content-end mb-3">
          <div className="position-relative" ref={dropdownRef1}>
            <button
              className="btn d-flex align-items-center gap-1 rounded-2"
              onClick={toggleDropdown1}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #E4E4E7",
                color: "#1F1F23",
                fontWeight: 500,
                padding: "6px 6px",
                fontSize:"12px"
              }}
            >
              <img
                src={exportIcon}
                alt="Export Icon"
                width="16"
                height="16"
                
              />
              Export
            </button>

            {showDropdown1 && (
              <div
                className="card shadow-sm position-absolute mt-2 end-0"
                style={{
                  width: "200px",
                  zIndex: 9999,
                  transform: "translateX(10px)",
                }}
              >
                <div>
                  <label className="bg-light py-1 px-2 w-100 fs-12">
                    Format
                  </label>
                  <div className="btn-group w-100 mt-2 px-2">
                    {formats.map((f) => (
                      <button
                        key={f.value}
                        className={`btn ${
                          format === f.value
                            ? "btn-dark"
                            : "btn-outline-dark"
                        }`}
                        onClick={() => setFormat(f.value)}
                      >
                        <i className={`bi ${f.icon}`}></i> {f.label}
                      </button>
                    ))}
                  </div>
                </div>
                
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-dark w-50 mt-3 mb-2 mx-2 fs-12"
                    onClick={() =>
                      exportReport(
                        filteredReport,
                        format,
                        filterDateWise.startDate,
                        filterDateWise.endDate
                      )
                    }
                  >
                    Export
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
          </div>
        </div>
      
        <div className="">
          <div className="table-responsive">
            <div className="table-scroll">
              <table className="table table-hover align-middle mt-0 rounded vertical-border">
                <thead className="bg-light text-nowrap fs-12 table-color">
                  <tr>
                    <th>Sr No</th>
                    <th>Entity</th>
                    <th>Branch ID</th>
                    <th>Legislation</th>
                    <th>Compliance Description</th>
                    <th>Audited Date</th>
                    <th>Due Date</th>
                    <th>Score</th>
                    <th>Auditor</th>
                    <th>Date of Compliance</th>
                    <th>Compliance Officer</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="fs-12 table-color">
                  {Array.isArray(currentItems) && currentItems.length > 0 ? (
                    currentItems.map((key, i) => (
                      <tr key={i}>
                        {/* <td><input type="checkbox" /></td> */}
                        <td>{key?.id ?? "NA"}</td>
                        <td>{key?.company_name || "NA"}</td>
                        <td>
                          <span
                            style={{
                              color: "#0d6efd",
                            }}
                          >
                            {key?.branch_id || "NA"}
                          </span>
                        </td>
                        <td>
                          {key?.legislation_name ? key?.legislation_name : "NA"}
                        </td>
                        <td>{key?.desc}</td>
                        <td>
                          {key?.audited_date
                            ? new Date(key.audited_date)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ (\w{3}) /, " $1, ")
                            : "NA"}
                        </td>
                        <style>
                          {`
  @keyframes blink {
  50% { opacity: 0; }
}
.blink {
  animation: blink 2s step-start infinite;
  font-weight: bold;
}
.text-green-600 {
  color: #16a34a; /* Tailwind green-600 */
}

.text-red-600 {
  color: #dc2626; /* Tailwind red-600 */
}  

`}
                        </style>
                        <td>
                          {key?.due_date ? (() => {
                            const dueDate = new Date(key.due_date);
                            const today = new Date();
                            const diffTime = dueDate - today;
                            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                            const formattedDate = dueDate
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ (\w{3}) /, " $1, ");

                            if (diffDays < 0) diffDays = 0;

                            // Blinking style for only days part
                            let blinkClass = "blink ";
                            if (diffDays > 0) {
                              blinkClass += "text-green-600"; // future
                            } else {
                              blinkClass += "text-red-600"; // today or overdue
                            }

                            return (
                              <span>
                                {formattedDate}{" "}
                                <span className={blinkClass}>({diffDays} days to go)</span>
                              </span>
                            );
                          })() : "NA"}
                        </td>
                        <td>
                          {key.curr === "Complied"
                            ? "1"
                            : key.curr === "Not Complied"
                              ? "0"
                              : key.curr === "Partial Complied"
                                ? "0.5"
                                : key.curr === "Not Applicable"
                                  ? "0"
                                  : "-"}
                        </td>
                        <td>{key?.assigned_auditor || "NA"}</td>
                        <td>
                          {key?.period
                            ? new Date(key.period)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ (\w{3}) /, " $1, ")
                            : "NA"}
                        </td>
                        <td>{key?.assigned_compliance_officer || "NA"}</td>
                        <td>
                         <button
  className="closeandopen-btn"
  onClick={() => getCopmlianceById(Number(key.id))}
  style={{
    color:
      Number(key.open_close) === 0
        ? "rgba(255, 140, 0, 1)"
        : "rgba(39, 181, 147, 1)",
  }}
>
  <img
    src={Number(key.open_close) === 0 ? VectorIcon : Closed}
    alt={Number(key.open_close) === 0 ? "open" : "closed"}
    style={{ width: 16, height: 16 }}
  />
  {Number(key.open_close) === 0 ? "Open" : "Closed"}
</button>


                           
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="9"
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          color: "#6c757d",
                          height: "600px",
                          fontSize: "12px"
                        }}
                      >
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {(showModal || loading) && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ maxWidth: "800px", width: "100%" }}
                  >
                    <div
                      className="modal-content p-4"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="modal-title fs-12">VERIFY REPORT</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowModal(false);
                            setFormData({
                              accepted: "",
                              comment: "",
                            });
                          }}
                        />
                      </div>
                      <form
                        onSubmit={(e) => handleUpdateModal(e, compliance?.id)}
                      >
                        <div>
                          <h4>
                            Compliance Action{" "}

                          </h4>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Compliance Description:{" "}
                            </strong>
                            {compliance?.compliance || "NA"}
                          </p>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Penalty Type:{" "}
                            </strong>
                            {compliance?.penalty_type || "NA"}
                          </p>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Penalty Description :{" "}
                            </strong>
                            {compliance?.penalty_description || "NA"}
                          </p>
                          <strong>Select Status</strong>
                          <br />
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              backgroundColor:
                                compliance?.current_compliance_status === "Complied"
                                  ? "#d1fae5"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "#fef9c3"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "#fee2e2"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "#e0f2fe"
                                        : "#ffe8dc", // fallback (light orange)
                              color:
                                compliance?.current_compliance_status === "Complied"
                                  ? "#065f46"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "#92400e"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "#991b1b"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "#1e40af"
                                        : "#9a3412", // fallback (dark orange)
                              border:
                                compliance?.current_compliance_status === "Complied"
                                  ? "1px solid #10b981"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "1px solid #facc15"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "1px solid #ef4444"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "1px solid #3b82f6"
                                        : "1px solid #f9964bff", // fallback (orange)
                              borderRadius: "4px",
                              padding: "4px 12px",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                backgroundColor:
                                  compliance?.current_compliance_status === "Complied"
                                    ? "#10b981"
                                    : compliance?.current_compliance_status === "Partial Complied"
                                      ? "#facc15"
                                      : compliance?.current_compliance_status === "Not Complied"
                                        ? "#ef4444"
                                        : compliance?.current_compliance_status === "Not Applicable"
                                          ? "#3b82f6"
                                          : "#f9964bff", // fallback (orange)
                                borderRadius: "50%",
                                marginRight: "8px",
                              }}
                            ></span>
                            {compliance?.current_compliance_status || "NA"}
                          </div>

                          <div className="mb-3">
                            <label className="form-label fw-semibold">
                              Attached Proof
                            </label>
                            {compliance?.proof_file ? (
                              <div className="d-flex gap-3 flex-wrap">
                                <div
                                  className="d-flex align-items-center justify-content-between border rounded px-3 py-2 shadow-sm"
                                  style={{ width: "320px" }}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <img
                                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                      alt="PDF icon"
                                      style={{ width: "32px", height: "32px" }}
                                    />
                                    <div
                                      className="fw-lighter text-dark"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {compliance?.proof_file
                                        ? compliance.proof_file.split("/").pop()
                                        : ""}
                                    </div>
                                  </div>
                                  <a
                                    href={`${API_URL}/${compliance.proof_file}`}
                                    className="text-primary fw-semibold fs-12"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View
                                  </a>
                                </div>
                              </div>
                            ) : (
                              <div className="fw-normal text-dark fs-12">NA</div>
                            )}
                          </div>
                          <div>
                            <label className="text-xs font-medium fs-12">
                              Attached Proof Link
                            </label>
                          </div>
                          <a
                            href={encodeURI(compliance?.proofs_link)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {compliance?.proofs_link || "NA"}
                          </a>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "16px",
                              paddingTop: "16px",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 45%",
                                minWidth: "280px",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  marginBottom: "4px",
                                }}
                              >
                                Auditor Comment
                              </h4>
                              <p
                                style={{
                                  fontSize: "12px",
                                  color: "#4b5563",
                                }}
                              >
                                {compliance?.comment_of_auditor || "NA"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select
            className="form-select form-select-sm w-auto"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size}>
                {size} per page
              </option>
            ))}
          </select>
        </div>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={handlePrevious}
              >
                Previous
              </button>
            </li>
            {startPage > 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}
            {pageNumbers.map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${currentPage === pageNum ? "active" : ""
                  }`}
              >
                <button
                  className={`page-link d-flex align-items-center justify-content-center fw-bold rounded-circle circle ${pageNum === currentPage
                              ? "bg-dark text-white"
                              : "text-dark bg-transparent"
                              } border-0`}
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}
            {endPage < totalPages && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={handleNext}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
export default ApproversReports;
